import { render, staticRenderFns } from "./customTransfer.vue?vue&type=template&id=2be551a8&scoped=true&"
import script from "./customTransfer.vue?vue&type=script&lang=js&"
export * from "./customTransfer.vue?vue&type=script&lang=js&"
import style0 from "./customTransfer.vue?vue&type=style&index=0&id=2be551a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be551a8",
  null
  
)

export default component.exports